// Unit economics: $/CPU-core-hr provisioned vs effective + utilization, with a
// per-capacity-type split — the "are we paying for idle" KPI row. Rendered as
// one hairline-divided StatStrip (numbers carry the hierarchy, no icon badges).

import React from 'react';
import { useUnitCosts } from '../../hooks/useFinopsV2';
import { formatPct } from './finopsFormat';
import { StatStrip, StatCell, Skeleton, ChDisabledCard } from './finopsUi';

const money4 = (v) => (v == null ? '—' : `$${Number(v).toFixed(4)}`);

export default function UnitCostTiles({ clusterId, hours }) {
  const { data, loading, available } = useUnitCosts(clusterId, hours);
  if (!available) return <ChDisabledCard title="Unit economics unavailable" />;
  if (loading) return <Skeleton className="h-24" />;
  if (!data || data.provisioned_cpu_core_hr_usd == null) return null;

  const spot = data.by_capacity_type?.spot?.provisioned_cpu_core_hr_usd;
  const od = data.by_capacity_type?.on_demand?.provisioned_cpu_core_hr_usd;

  return (
    <StatStrip>
      <StatCell label="$ / CPU-hr provisioned" value={money4(data.provisioned_cpu_core_hr_usd)}
                sub="what a provisioned core costs" />
      <StatCell label="$ / CPU-hr effective" value={money4(data.effective_cpu_core_hr_usd)}
                sub="cost ÷ cores actually used" />
      <StatCell label="CPU utilization" value={formatPct(data.cpu_utilization_pct)}
                sub="used ÷ provisioned core-hours"
                tone={data.cpu_utilization_pct >= 50
                  ? 'text-emerald-600 dark:text-emerald-400'
                  : 'text-amber-600 dark:text-amber-400'} />
      <StatCell label="Spot vs on-demand $/hr"
                value={spot != null || od != null ? `${money4(spot)} / ${money4(od)}` : '—'}
                sub="provisioned CPU-hr by capacity" />
    </StatStrip>
  );
}
